<template>
    <ToolButton :Editor="Editor" KnownIcon="TableDeleteRow" @ToolClick="Editor.chain().focus().deleteRow().run()">

    </ToolButton>
</template>
<script>

import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

export default ({
    components: {
        ToolButton
    },
    props: ["Editor"]
});
</script>